let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("lyxzP"), load("gcXcg"), load("4gtMV"), load("8wMGm"), load("c6MKV"), load("anGwD")]).then(() => parcelRequire('1nPts'));